import React, { PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { autorun, observable, toJS } from 'mobx';
import Form, { FormBody, SelectInput, TextInput } from '../../Form';
import Spinner from "../../Spinner";
import TicketLogRoot from "./Log/TicketLogRoot";
import TicketFollower from "./Followers/TicketFollower";
import { Link } from "react-router";
import { sort } from '../helper';
import { getDisplayDate } from "../../../libs/date";
import { action } from "mobx/lib/mobx";
import moment from 'moment';
import { smtpConfig as api } from "../../Maintenance/api";

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'surveyStore', 'surveyTemplateStore')
@observer
export default class TicketView extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.params.ticket_id ? `/station/${this.props.params.id}/maintenance/ticket/${this.props.params.ticket_id}/view` : `/monitoring/ticket/tabular/${this.props.params.id}/view`;

  @observable ticket = null;
  @observable editMode = false;
  @observable surveyReport = null;

  @observable item = {
    name:'',
    userName:''
  };

  dispose;

  componentDidMount() {
    const { ticketStore, params: { ticket_id, id }, surveyStore, surveyTemplateStore, userStore } = this.props;
    ticketStore.fetchTicketById(ticket_id || id);
    this.dispose = autorun(() => {
      let ticket = ticketStore.ticket;
      if (!!ticket) {
        this.ticket = ticket;
        surveyStore.fetchItems({ station_id: ticket.station_id, date_from: ticket.generated_date, date_to: moment.utc().format('YYYY-MM-DD') })
          .then((surveyData) => {
            if (!!surveyData.length) {
              this.surveyReport = surveyData.find((survey) => survey.ticket_id === ticket.id)
              if (!surveyTemplateStore.items.length) surveyTemplateStore.fetchItems();
            }
          })

      }
    });

    api.fetch().then(json => {
      let data = userStore.findById(json.support_user_id)
     this.item.user = data && data.name
     this.item.userName = data && data.username
    }).catch(console.error);
  }

  componentWillReceiveProps(nextProps) {
    const { ticketStore, params: { ticket_id, id } } = nextProps;
    if (this.ticket.id !== ticket_id && this.ticket.id !== id) ticketStore.fetchTicketById(ticket_id || id);
  }

  componentWillUnmount() {
    this.props.ticketStore.clearTicketView();

    if (this.dispose) {
      this.dispose();
    }
  }

  @action onChangeStation = e => this.ticket.station_id = +e.target.value;
  @action onChangeSummary = e => this.ticket.summary = e.target.value;
  @action onChangeDescription = e => this.ticket.description = e.target.value;
  @action onChangeAssignedTo = e => this.ticket.assigned_to = +e.target.value;
  @action onChangeStatus = e => this.ticket.status_id = +e.target.value;
  @action onChangeReason = e => this.ticket.reason_id = +e.target.value;
  @action onChangeAction = e => this.ticket.action_id = +e.target.value;

  onClickAddWorkOrder = e => {
    e.preventDefault();
    const { params: { ticket_id, id } } = this.props;
    if (!ticket_id) this.context.router.push(`/monitoring/ticket/tabular/${id}/view/work_order/add`);
    else this.context.router.push(`/station/${id}/maintenance/ticket/${ticket_id}/view/work_order/add`);
  };

  onClickArchive = (e) => {
    e.preventDefault();
    const { params: { ticket_id, id }, ticketStore } = this.props;
    const { notify } = this.context;
    let message = this.ticket.archived ? 'Ticket removed from archive' : 'Ticket moved to archive';
    let { archived, ...others } = ticketStore.findById(ticket_id || id).asJson;

    ticketStore.updateItem(Object.assign({}, { id: ticket_id || id, archived: !this.ticket.archived, ...others })).then(() => {
      ticketStore.fetchTicketById(ticket_id || id);
      this.ticket.archived = !this.ticket.archived;
      notify.success({ message })
    });
  };

  onClickTicketEdit = (e) => {
    e.preventDefault();
    if (this.editMode) {
      // save ticket
      let payload = [
        "action_id",
        "archived",
        "assigned_to",
        "description",
        "email_address",
        "end_date",
        "generated_date",
        "id",
        "last_log",
        "mobile_no",
        "name",
        "reason_id",
        "station_id",
        "status_id",
        "summary",
      ].reduce((acc, key) => (Object.assign(acc, { [key]: this.ticket[key] })), {});
      this.props.ticketStore.updateItem(payload);
    }
    this.editMode = !this.editMode;
  };

  onCancelTicketEdit = (e) => {
    e.preventDefault();
    this.ticket = this.props.ticketStore.ticket;
    this.editMode = false;
  };

  onNext = (e) => {
    e.preventDefault();

    const { ticketStore, view_archived } = this.props;
    const { filteredTickets, items } = ticketStore;

    let currentIndex, nextTicket;

    if (this.props.params.ticket_id) {
      const tickets = items.filter(item => +item.station_id === +this.props.params.id).filter(item => view_archived ? true : !item.archived);

      currentIndex = tickets.findIndex(ticket => +ticket.id === +this.props.params.ticket_id);
      nextTicket = tickets[currentIndex + 1];

      if (nextTicket)
        this.context.router.push(`/station/${this.props.params.id}/maintenance/ticket/${nextTicket.id}/view`);
    } else {
      currentIndex = filteredTickets.findIndex(ticket => +ticket.id === +this.ticket.id);
      nextTicket = filteredTickets[currentIndex + 1];
      if (nextTicket)
        this.context.router.push(`/monitoring/ticket/tabular/${nextTicket.id}/view`);
    }
  }

  onPrevious = (e) => {
    e.preventDefault();

    const { ticketStore, view_archived } = this.props;
    const { filteredTickets, items } = ticketStore;

    let currentIndex, previousTicket;

    if (this.props.params.ticket_id) {
      const tickets = items.filter(item => +item.station_id === +this.props.params.id).filter(item => view_archived ? true : !item.archived);

      currentIndex = tickets.findIndex(ticket => +ticket.id === +this.props.params.ticket_id);
      previousTicket = tickets[currentIndex - 1];

      if (previousTicket)
        this.context.router.push(`/station/${this.props.params.id}/maintenance/ticket/${previousTicket.id}/view`);
    } else {
      currentIndex = filteredTickets.findIndex(ticket => +ticket.id === +this.ticket.id);
      previousTicket = filteredTickets[currentIndex - 1];

      if (previousTicket)
        this.context.router.push(`/monitoring/ticket/tabular/${previousTicket.id}/view`);
    }
  }

  render() {
    const { params: { ticket_id, id }, ticketStore, stationStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, surveyTemplateStore } = this.props;
    if (!this.ticket || stationStore.isLoading || ticketStore.isLoading || stationStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading) return <Spinner />;

    let station = stationStore.findById(this.ticket.station_id);
    let status = ticketStatusStore.findById(this.ticket.status_id),
      reason = ticketReasonStore.findById(this.ticket.reason_id),
      // created_by = userStore.findById(this.ticket.user_id),
      action = ticketActionStore.findById(this.ticket.action_id);



    let surveyReportTemplate = surveyTemplateStore.findById(this.surveyReport && this.surveyReport.survey_template_id);
    if (!station) return <Spinner />

    return (
      <div className='full-width'>
        <div className='inline-grid space-between'>
          <button className='button' style={{ width: '150px' }} onClick={this.onPrevious}><i style={{ margin: '0 5px 0 -5px' }} className={'fa fa-arrow-left white'} />Previous</button>
          <button className='button' style={{ width: '150px' }} onClick={this.onNext}>Next<i style={{ margin: '0 -5px 0 5px' }} className={'fa fa-arrow-right white'} /></button>
        </div>
        <Form>
          <FormBody>
            <div className='inline-grid v-center'>
              <div className='ticket-title flex-grow'><i className='fa fa-caret-right' style={{ fontSize: '25px', marginRight: '10px' }} />
                {!this.editMode ? this.ticket.summary : <input className='ticket-title-edit' value={this.ticket.summary} onChange={this.onChangeSummary} autoFocus />}
              </div>
              <div>
                {this.editMode ? <button className='button button-inactive' onClick={this.onCancelTicketEdit}><i className='fa fa-close' /> {'Cancel'}</button> : <button className='button button-inactive' onClick={this.onClickArchive}><i className='fa fa-archive' /> {this.ticket.archived ? 'Unarchive' : 'Archive  '}</button>}
                <button className='button' onClick={this.onClickTicketEdit}><i className={this.editMode ? 'fa fa-save' : 'fa fa-edit'} /> {this.editMode ? 'Save' : 'Edit'}</button>
              </div>
            </div>
            <div className='inline-grid space-between overflow-x-hidden'>
              <div>
                <TextInput value={this.ticket.id} label='Ticket Number' readOnly />
                <TextInput value={station.identifier} label='Station Identifier' readOnly />
                {/*<TextInput value={<a href={`/station`}>{this.ticket.station_name}</a>} label='Station Name' readOnly/>*/}
                {!this.editMode ? <div className='formInput'>
                  <label>Station Name</label>
                  <a href={`#/station/${this.ticket.station_id}/monitoring`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}>{station.name}</a>
                </div> : <SelectInput
                  label={'Station Name'}
                  value={this.ticket.station_id}
                  options={stationStore.items}
                  onChange={this.onChangeStation}
                  fields={{
                    label: 'name',
                    value: 'id',
                  }}
                />}
                <TextInput value={getDisplayDate(this.ticket.generated_date)} label='Creation Date' readOnly />
                {this.surveyReport &&
                  <div className='formInput'>
                    <label>Maintenance Report</label>
                    <a href={`#/monitoring/survey/history/${this.surveyReport.id}`}
                      target='_blank'
                      className={'button button-inactive'}
                      style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}
                    >
                      {surveyReportTemplate ? surveyReportTemplate.name : 'View Report'}
                    </a>
                  </div>
                }
              </div>
              <div>
                {!this.editMode ? <TextInput value={status.caption} label='Status' readOnly /> : <SelectInput
                  label={'Status'}
                  value={this.ticket.status_id}
                  options={ticketStatusStore.items}
                  onChange={this.onChangeStatus}
                  fields={{
                    label: 'caption',
                    value: 'id',
                  }}
                />}
                {!this.editMode ? <TextInput value={reason.caption} label='Reason' readOnly /> : <SelectInput
                  label={'Reason'}
                  value={this.ticket.reason_id}
                  options={ticketReasonStore.items}
                  onChange={this.onChangeReason}
                  fields={{
                    label: 'caption',
                    value: 'id',
                  }}
                />}
                {!this.editMode ? <TextInput value={action.caption} label='Action' readOnly /> : <SelectInput
                  label={'Action'}
                  value={this.ticket.action_id}
                  options={ticketActionStore.items}
                  onChange={this.onChangeAction}
                  fields={{
                    label: 'caption',
                    value: 'id',
                  }}
                />}
                 <TextInput value={`${this.item.user} (${this.item.userName})`} label='Created By' readOnly />
              </div>
              <div>
                <TextInput value={this.ticket.name} label='Name' readOnly={!this.editMode} />
                <TextInput value={this.ticket.email_address} label='Email' readOnly={!this.editMode} />
                <TextInput value={this.ticket.mobile_no} label='Phone' readOnly={!this.editMode} />
                <div className='formInput flex flex-row'>
                  <label>Work Order</label>
                  <div className='input flex' style={{ maxWidth: '150px', overflowY: 'scroll' }}>
                    <div className='flex flex-row flex-grow'>
                      {this.ticket.work_order && sort(this.ticket.work_order, 'id').map((item, i) =>
                        <div key={`ticket_work_order_${item.id}_${i}`} style={{ marginRight: '5px', cursor: 'pointer' }} className='chip' onClick={() => {
                          this.context.router.push(
                            this.props.params.ticket_id ?
                              `station/${id}/maintenance/work_order/${item.id}/view` :
                              `/monitoring/work_order/tabular/${item.id}/view`
                          );
                        }}>
                          {item.id}
                        </div>)}
                    </div>
                    <i className='fa fa-plus' onClick={this.onClickAddWorkOrder} />
                  </div>
                </div>
              </div>
            </div>

            <div className='logs-container'>
              <h4 style={{ margin: 0 }}>Description</h4>
              <div style={{ padding: 15 }}>
                {!this.editMode ? (this.ticket.description || '').split('\n').map((item, i) => <p key={`ticket-${this.ticket.id}-description-line-${i}`}>{item}</p>) : <textarea
                  value={this.ticket.description.replace(/\/n/g, '\n')}
                  style={{ width: '95%', padding: 10, borderColor: 'lightgrey' }}
                  rows={this.ticket.description.replace(/\/n/g, '\n').split('\n').length}
                  onChange={this.onChangeDescription}
                />}
              </div>
            </div>

          </FormBody>
        </Form>
        <br />
        <div className='ticket-list-map'>
          <div className='flex-grow overflow-x-scroll'>
            <TicketLogRoot ticket_id={ticket_id || id} />
          </div>
          <TicketFollower ticket_id={ticket_id || id} />
        </div>
        {this.props.children ? React.cloneElement(this.props.children, { slug: this.slug }) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketView.js